export default __webpack_public_path__ + "static/media/a2-4-19.61e5c0c7.jpg";